import type { HTMLAttributes, ReactNode } from "react";
import { injectCss } from "../core/injectCss";

const CSS = `
.js-empty{
  display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;
  padding:48px 24px;font-family:var(--font-sans);gap:6px;
}
.js-empty__icon{
  width:64px;height:64px;border-radius:var(--radius-xl);display:flex;align-items:center;justify-content:center;
  background:var(--brand-subtle);color:var(--brand);margin-bottom:10px;
}
.js-empty__title{font-size:var(--text-h3);font-weight:var(--weight-bold);color:var(--text-strong)}
.js-empty__desc{font-size:var(--text-sm);color:var(--text-muted);max-width:320px;line-height:var(--leading-normal)}
.js-empty__action{margin-top:14px}
`;

export interface EmptyStateProps extends HTMLAttributes<HTMLDivElement> {
  icon?: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({ icon, title, description, action, className = "", ...rest }: EmptyStateProps) {
  injectCss("js-empty-css", CSS);
  return (
    <div className={["js-empty", className].filter(Boolean).join(" ")} {...rest}>
      {icon && <span className="js-empty__icon">{icon}</span>}
      {title && <div className="js-empty__title">{title}</div>}
      {description && <div className="js-empty__desc">{description}</div>}
      {action && <div className="js-empty__action">{action}</div>}
    </div>
  );
}
